import { AllFieldValueTypes } from '90.quickConnect.Models/models';

/** Nombre entier ou décimal, séparateur point ou virgule, exposant accepté (comme Double.parseDouble sous Android) */
const numericStringPattern = /^[-+]?(\d+([.,]\d*)?|[.,]\d+)([eE][-+]?\d+)?$/;

/**
 * Conversion d'une valeur en booléen, alignée sur Android (BooleanFormatExtension.convertFromString) :
 * - booléen : inchangé ;
 * - nombre, entier ou décimal : true s'il est différent de zéro (2, -1, 0.5 => true ; 0 => false) ;
 * - chaîne : libellés 'true'/'vrai' et 'false'/'faux' (casse ignorée), puis nombre entier ou décimal
 *   (point ou virgule) : true s'il est différent de zéro ('4', '0,5' => true ; '0', '0.0' => false) ;
 * - toute autre valeur : undefined (Android : valeur non reconnue, la case garde sa valeur).
 * Spécificités web conservées : chaîne vide ou blanche => false, 'TrueOnDevice' => true.
 * Avant le 25/10/2026, seuls 1 et '1' valaient true : 2, 4 ou 0.5 donnaient false, contrairement à Android.
 */
const convertToBooleanValue = (value: AllFieldValueTypes): boolean | undefined => {
  if (typeof value === 'boolean') return value;

  if (typeof value === 'number') return !Number.isNaN(value) && value !== 0;

  if (typeof value === 'string') {
    const lowerValue = value.toLowerCase();
    if (['true', 'vrai'].includes(lowerValue)) return true;
    if (['false', 'faux'].includes(lowerValue)) return false;
    if (value === 'TrueOnDevice') return true;

    const trimmedValue = value.trim();
    if (trimmedValue === '') return false;
    if (numericStringPattern.test(trimmedValue)) return Number(trimmedValue.replace(',', '.')) !== 0;
  }

  return undefined;
};

export default convertToBooleanValue;
